<template>
  <div id="create-landings">
    <SidebarLayout3 :breadcrumb="breadcrumbs" :pageTitle="pageTitle">
      <template #sidebar>
        <div class="sidebar">
          <Heading class="sidebar--title">
            Ações da página
          </Heading>
          <span class="sidebar--button">
            <Button
              :disabled="disabledSaveButton"
              tooltipText="Adicione um nome para salvar"
              class="sidebar--button__save"
              @click="saveLanding"
            >
              Salvar
            </Button>
            <Button
              v-show="$route.params.id"
              variation="error"
              class="sidebar--button__delete"
              @click="showModal = true"
            >
              Excluir
            </Button>
            <Button
              layout="outline"
              class="sidebar--button__cancel"
              @click="$router.push({ path: '/landings' })"
            >
              Voltar sem salvar
            </Button>
          </span>
          <Heading class="sidebar--tip">
            Dica
          </Heading>
          <Paragraph class="sidebar--tip-text">
            Crie Coleções de Hotéis para personalizar a exibição de suas
            propriedades no site Letsbook. <br /><br />
            Exemplo: Utilize essas coleções para destacar hotéis em landings
            promocionais ou para organizar listagens por destino, oferecendo uma
            experiência de navegação otimizada aos seus clientes.
          </Paragraph>
        </div>
      </template>
      <template #content>
        <FormInput
          v-model="landingName"
          label="Nome da coleção"
          placeholder="Insira o nome da coleção"
          class="name-input"
          required
        />
        <Heading :level="4" class="info-head">
          Selecione os hotéis que deseja adicionar em uma coleção
        </Heading>
        <Paragraph class="info-text">
          Ao adicionar hotéis, você poderá utilizar eles como uma coleção no seu
          site Letsbook e landings promocionais.
        </Paragraph>
        <span class="main-content">
          <SelectionBox
            v-model="selectedHotels"
            :list="hotelsList"
            placeholder="Busque pelo nome do hotel"
            selectedPlaceholder="Busque pelo nome do hotel selecionado"
            titleFirstBox="Adicionar hotéis"
            titleSecondBox="Hotéis selecionados"
          >
          </SelectionBox>
          <InfoTooltip
            class="main-content--info-tooltip"
            text="Hotéis selecionados para este Site. Caso nenhum esteja selecionado, serão considerados todos."
          />
        </span>
        <span class="footer">
          <Button
            layout="outline"
            class="footer--button"
            @click="$router.push({ path: '/landings' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            :disabled="disabledSaveButton"
            popperStrategy="absolute"
            tooltipText="Adicione um nome para salvar"
            class="footer--button"
            @click="saveLanding"
          >
            Salvar agrupador
          </Button>
        </span>
        <AlertModal
          v-model="showModal"
          :buttonClose="true"
          icon="trash-can"
          title="Excluir agrupador de hotéis"
          @alert-modal-confirm="deleteLanding"
        >
          <template #text>
            Ao excluir um grupo de hotéis que pode estar sendo utilizado em
            algum site a integração será afetada. <br />
            Tem certeza que quer fazer isso?
          </template>
        </AlertModal>
      </template>
    </SidebarLayout3>
  </div>
</template>

<script>
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import SelectionBox from '@/components/_base/patterns/SelectionBox'
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'CreateLandings',
  components: {
    AlertModal,
    Button,
    FormInput,
    Heading,
    InfoTooltip,
    Paragraph,
    SelectionBox,
    SidebarLayout3
  },
  data() {
    return {
      /** Caminho de pão */
      breadcrumbs: [
        {
          label: 'Site Let’s Book'
        },
        {
          label: 'Coleção de hotéis',
          url: '/landings',
          isSpa: true
        },
        {
          label: 'Criar nova Coleção de hotéis'
        }
      ],
      /** Lista de opções de hotéis */
      hotelsList: [],
      /** Nome da landing (v-model input de texto) */
      landingName: '',
      /** Título da página */
      pageTitle: 'Criar nova Coleção de hotéis',
      /** Lista de hotéis selecionados (v-model) */
      selectedHotels: [],
      /** Renderização da modal */
      showModal: false
    }
  },
  computed: {
    /** Habilitação do botão de salvar */
    disabledSaveButton() {
      /** Retorna true (desabilitado) se o nome estiver vazio */
      if (this.landingName.trim() === '') {
        return true
      }
      return false
    }
  },
  async created() {
    this.getHotelsList()
    /** Se a rota tiver id, é tela de edição */
    if (this.$route.params.id) {
      await this.getLandingById()
    }
  },
  methods: {
    getHotelsList() {
      this.$hotel.getShortenedHotelsList().then((res) => {
        this.hotelsList = this.formatHotelsData(res.data)
      })
    },
    /** Exclui a landing */
    deleteLanding() {
      const id = [parseInt(this.$route.params.id)]
      this.$landings
        .deleteLanding({ landings: id })
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Grupo de hotéis excluído'
          })
        })
        .catch(() => {
          /** Feedback de erro */
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir'
          })
        })
        .finally(() => {
          /** Retorna à página de listagem */
          this.$router.push({ path: '/landings' })
        })
    },
    formatHotelsData(data) {
      const array = []
      data.forEach((hotel) => {
        array.push({
          id: hotel.codigo,
          text: hotel.nome
        })
      })
      return array
    },
    /** Traz os dados para edição */
    getLandingById() {
      this.$landings.getLandings(this.$route.params.id).then((response) => {
        const info = response.data
        this.landingName = info.nome
        this.pageTitle = 'Editando ' + info.nome
        this.breadcrumbs[2].label = this.pageTitle
        this.selectedHotels = info.hoteis.map((item) => {
          const obj = {}
          obj.id = item.codigo
          obj.text = item.nome
          return obj
        })
      })
    },
    /** Salva os dados alterados */
    saveLanding() {
      /** Se nenhum hotel for selecionado, considera todos os hotéis como selecionados */
      if (this.selectedHotels.length === 0) {
        this.selectedHotels = this.hotelsList
      }
      const hotelsList = this.selectedHotels.map((item) => item.id)

      /** Se a rota tiver id, é edição */
      if (this.$route.params.id) {
        this.$landings
          .editLanding({
            nome: this.landingName,
            codigo: parseInt(this.$route.params.id),
            hoteis: hotelsList
          })
          .then(() => {
            /** Feedback de sucesso */
            this.$router.push({ path: '/landings' })
            this.$bus.$emit('show-alert-chip', {
              message: 'Grupo de hotéis alterado com sucesso'
            })
          })
          .catch((err) => {
            /** Feedback de erro */
            this.$bus.$emit('show-alert-chip', {
              message:
                err?.messages?.[0] ||
                'Já existe uma coleção de hotel cadastrada com esse nome.'
            })
          })
        /** Se a rota não tiver id, é criação */
      } else {
        this.$landings
          .createLanding({ nome: this.landingName, hoteis: hotelsList })
          .then(() => {
            this.$router.push({ path: '/landings' })
            this.$bus.$emit('show-alert-chip', {
              message: 'Grupo de hotéis criado com sucesso'
            })
          })
          .catch((err) => {
            this.$bus.$emit('show-alert-chip', {
              message:
                err?.messages?.[0] ||
                'Já existe uma coleção de hotel cadastrada com esse nome.'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}

.sidebar {
  width: 215px;
  padding: 35px 0 0 15px;

  &--button {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 25px;
  }

  &--tip-text {
    line-height: 21px;
  }
}

.name-input {
  width: 390px;
  margin-bottom: 32px;
}

.info-text {
  color: $gray-dark;
  margin-bottom: 32px;
}

.main-content {
  display: flex;
  &--empty-text {
    font-size: font-size('size-small');
    line-height: 18px;
    color: $gray-dark;
    text-align: center;
  }
  &--info-tooltip {
    margin-left: -250px;
    color: $gray-dark;
  }
}
.footer {
  display: flex;
  margin-top: 68px;
  justify-content: space-between;
  &--button {
    width: 215px;
  }
}
</style>
